export const HashtagActionType = {
  GET_HASHTAG_LIST: 'GET_HASHTAG_LIST',
  ADD_HASHTAG: 'ADD_HASHTAG',
  UPDATE_HASHTAG: 'UPDATE_HASHTAG',
  FILTER_HASHTAGS_FULFILLED: 'FILTER_HASHTAGS_FULFILLED',
  DELETE_HASHTAGS_FULFILLED: 'DELETE_HASHTAGS_FULFILLED',
};
